/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable, of} from 'rxjs';
import { JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';

@Injectable({
  providedIn: 'root'
})
export class DeliveryEmployeeDispatcherResourceService {
  private readonly url: string | undefined = undefined;

  constructor(private httpClient: HttpClient, environmentService: EnvironmentService) {

    this.url = environmentService.getEnvironmentProperty('deliveryDispatcherResourceUrl');
  }

  findAll(query?: any,
          additionalParams?: any): Observable<JsonApiResource<DelEmployeeVoModel[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []).toString();

    return <Observable<JsonApiResource<DelEmployeeVoModel[], any>>>this.httpClient.get(`${this.url}${queryString}`);
  }

  save(): Observable<any> {
    return of();
  }
}
